/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { useTheme } from '@emotion/react'

import { IconProps } from '../../types'

export const Search = ({ size = 17, fill, ...rest }: IconProps) => {
  const { colors } = useTheme()
  fill = fill ?? colors.textLight
  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 17 17"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M15.2642 16.5984C15.5947 16.9317 16.1329 16.9339 16.4662 16.6033C16.7995 16.2728 16.8018 15.7346 16.4712 15.4013L15.2642 16.5984ZM10.5372 11.8322L15.2642 16.5984L16.4712 15.4013L11.7442 10.6351L10.5372 11.8322Z"
        fill={fill}
      />
      <path
        d="M12.52 6.74038C12.52 10.0002 9.90094 12.6308 6.68498 12.6308C3.46901 12.6308 0.85 10.0002 0.85 6.74038C0.85 3.48058 3.46901 0.85 6.68498 0.85C9.90094 0.85 12.52 3.48058 12.52 6.74038Z"
        stroke={fill}
        strokeWidth="1.7"
      />
    </svg>
  )
}
